/**
 *  @class
 *  @function ScrollingBoxes
 */
if (!customElements.get('scrolling-boxes')) {
  class ScrollingBoxes extends HTMLElement {
    connectedCallback() {
      this.inner = this.querySelector('.scrolling-boxes--inner');

      this.setupVideos();
      this.setupScroll();
    }
    disconnectedCallback() {
      if (this._scrollTrigger) {
        this._scrollTrigger.kill();
        this._scrollTrigger = null;
      }
    }
    setupVideos() {
      this._onEnter = (e) => {
        const video = e.currentTarget.querySelector('.scrolling-boxes--video video');
        if (video) video.play();
      };
      this._onLeave = (e) => {
        const video = e.currentTarget.querySelector('.scrolling-boxes--video video');
        if (video) video.pause();
      };

      this.querySelectorAll('.scrolling-boxes--box').forEach((box) => {
        const container = box.querySelector('.scrolling-boxes--video');
        if (!container) return;
        const video = container.querySelector('video');
        if (!video) return;

        if (container.classList.contains('hover-play')) {
          video.currentTime = 0.1;
          box.addEventListener('mouseenter', this._onEnter);
          box.addEventListener('mouseleave', this._onLeave);
        } else {
          video.play();
        }
      });
    }
    setupScroll() {
      const start = this.dataset.sectionIndex == 1 ? "top top" : "center center",
        dir = document.dir === 'rtl' ? 1 : -1,
        inner = this.inner;

      const getEndX = () => dir * (inner.scrollWidth - document.documentElement.clientWidth);

      this._scrollTrigger = ScrollTrigger.create({
        trigger: inner,
        start: start,
        invalidateOnRefresh: true,
        pin: true,
        scrub: 1,
        animation: gsap.to(inner, {
          x: getEndX,
          ease: "none"
        }),
        onRefresh: () => {
          gsap.set(inner, { x: getEndX() });
        }
      });
    }
  }
  customElements.define('scrolling-boxes', ScrollingBoxes);
}

